export const SHOW_LOADING = "show_loading"
export const HIDE_LOADING = "hide_loading"

export const IS_LOGIN = "login_user"
export const IS_LOGOUT = "logout_user"
export const PERSIST_AUTH = "persist_auth"
export const CLEAR_STORE = "clear_all_states"
export const LOGIN_ERROR = "error_in_login"
export const CLEAR_LOGIN_ERROR = "clear_error_in_login"

// WebAuthn second-factor pre-auth flow (password OK, not yet logged in).
export const WEBAUTHN_PREAUTH = "webauthn_preauth"
export const WEBAUTHN_FLOW_RESET = "webauthn_flow_reset"

export const FETCHED_ALL_MATCHES = "fetch_all_matches"
export const CLEAR_MATCHES = "clear_previous_stored_matches"
export const RETURN_MATCHES_ERROR = "error_in_fetching_matches"

export const FETCHED_TEAM_A_MAPPING = "fetched_team_a_mapping"
export const FETCHED_TEAM_B_MAPPING = "fetched_team_b_mapping"
export const CLEAR_PLAYER_MATCH_MAPPING = "clear_player_match_mapping"
export const RETURN_PLAYER_MATCH_MAPPING_ERROR =
  "return_player_match_mapping_error"

export const STORE_MATCH_STRING = "store_match_string"
export const CLEAR_MATCH_STRING = "clear_match_string"
export const STORE_ANALYSIS_RESULT = "store_analysis_result"
export const SHOW_ANALYSIS_LOADING = "show_analysis_loading"
export const HIDE_ANALYSIS_LOADING = "hide_analysis_loading"
export const CLEAR_ANALYSIS_RESULT = "clear_analysis__result"
export const ANALYSIS_STRING_ERROR = "analysis_string_error"
export const CLEAR_ANALYSIS_STRING_ERROR = "clear_analysis_string_error"
export const ANALYSIS_CAN_OVERRIDE = "analysis_can_override"

export const SET_VIDEO_CONTROL = "set_video_control"
export const UPDATE_VIDEO_TIME = "update_video_time"
export const LOAD_VIDEO_URL = "load_video_url"
export const CLEAR_VIDEO_URL = "clear_video_url"
export const VIDEO_SEEK_TIME = "video_seek_time"
export const CLEAR_SEEK_FLAG = "clear_seek_flag"

export const SET_CURRENT_ACTION = "set_current_action"
export const SET_FULL_ANALYSE_STRING = "set_full_string_analyse"
export const CLEAR_CURRENT_ACTION = "set_current_action"
export const CLEAR_FULL_ANALYSE_STRING = "clear_full_string_analyse"
export const UPDATE_ACTION_LOG = "update_action_log"
export const CLEAR_ACTION_LOG = "clear_action_log"
export const CONTROLLER_TOGGLE = "toggle_controller_window"

export const MATCH_MAPPING_UPDATE_INIT = "match_update_init"
export const MATCH_MAPPING_UPDATE_SUCCESS = "match_update_success"
export const MATCH_MAPPING_UPDATE_FAILED = "match_update_failed"

export const PUSH_MATCH_STRING_SERVER_SUCCESS =
  "push_match_string_to_server_success"
export const PUSH_MATCH_STRING_SERVER_FAILED =
  "push_match_string_to_server_failed"
export const FETCH_MATCH_STRING_SERVER_SUCCESS =
  "fetch_match_string_from_server_success"
export const FETCH_MATCH_STRING_SERVER_FAILED =
  "fetch_match_string_from_server_failed"
